import './Photo.scss';
import Component from './Photo.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);